"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactStaticGoogleMap = require("react-static-google-map");

var _Card = _interopRequireDefault(require("../Card"));

var _Skeleton = _interopRequireDefault(require("../Skeleton"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme3 = _interopRequireDefault(require("../styles/useTheme"));

var _Text = _interopRequireDefault(require("../Text"));

var _useIsLoading = _interopRequireDefault(require("./LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("./TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme3["default"])(),
      spacing = _useTheme.spacing;

  return (0, _react.useMemo)(function () {
    return {
      card: {
        position: 'relative',
        overflow: 'hidden',
        paddingTop: '56.25%',
        // 16:9 Aspect Ratio
        minHeight: spacing(16),
        minWidth: spacing(42),
        // just in case
        maxWidth: '100%'
      },
      container: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center'
      },
      staticMap: {
        width: '100%'
      }
    };
  }, [spacing]);
};

__signature__(useStyles, "useTheme{{ spacing }}\nuseMemo{}", function () {
  return [_useTheme3["default"]];
});

var StaticMap = function StaticMap(props) {
  var _props$latitude = props.latitude,
      latitude = _props$latitude === void 0 ? 0 : _props$latitude,
      _props$longitude = props.longitude,
      longitude = _props$longitude === void 0 ? 0 : _props$longitude,
      _props$radius = props.radius,
      radius = _props$radius === void 0 ? 1000 : _props$radius,
      googleMapsApiKey = props.googleMapsApiKey,
      other = (0, _objectWithoutProperties2["default"])(props, ["latitude", "longitude", "radius", "googleMapsApiKey"]); // we divide this to have the same radius scale than with the dynamic map

  var staticMapRadius = radius / 100000;
  var t = (0, _useTranslation["default"])();
  var classes = useStyles();
  var isLoading = (0, _useIsLoading["default"])();

  var _useTheme2 = (0, _useTheme3["default"])(),
      colors = _useTheme2.colors;

  var convertedTo0xPrimary = colors.primary.replace('#', '0x');
  var circle = (0, _react.useMemo)(function () {
    var points = [];
    var numberOfPoints = 40;

    for (var i = 0; i < numberOfPoints; i += 1) {
      var pointLat = Math.cos(i / numberOfPoints * 2 * Math.PI) * staticMapRadius + latitude;
      var pointLng = Math.sin(i / numberOfPoints * 2 * Math.PI) * staticMapRadius * 1.48 + longitude;
      points.push("".concat(pointLat, ",").concat(pointLng));
    }

    return [].concat(points, [points[0]]);
  }, [latitude, longitude, radius]);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column",
    width: "100%",
    padding: 4
  }, other), (0, _core.jsx)(_Text["default"], {
    as: "h2",
    variant: "headline3",
    gutter: 2
  }, t('work_location')), (0, _core.jsx)(_Card["default"], {
    elevation: 1,
    flex: 1,
    css: classes.card,
    maxWidth: "100%"
  }, (0, _core.jsx)(_Flex["default"], {
    css: classes.container
  }, isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    minHeight: "100%",
    minWidth: "100%",
    variant: "rect"
  }) : (0, _core.jsx)(_reactStaticGoogleMap.StaticGoogleMap, {
    size: "550x550",
    maptype: "roadmap",
    zoom: 14,
    apiKey: googleMapsApiKey,
    css: classes.staticMap
  }, (0, _core.jsx)(_reactStaticGoogleMap.Path, {
    color: convertedTo0xPrimary,
    fillcolor: convertedTo0xPrimary,
    weight: "3",
    points: circle
  })))));
};

__signature__(StaticMap, "useTranslation{t}\nuseStyles{classes}\nuseIsLoading{isLoading}\nuseTheme{{ colors }}\nuseMemo{circle}", function () {
  return [_useTranslation["default"], useStyles, _useIsLoading["default"], _useTheme3["default"]];
});

var _default = (0, _react.memo)(StaticMap);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/StaticMap.tsx");
  reactHotLoader.register(StaticMap, "StaticMap", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/StaticMap.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/StaticMap.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();